export var Colors = /*#__PURE__*/ function(Colors) {
    Colors["Aqua"] = "var(--color-semantic-surface-highlight-smoke-moderate)";
    Colors["BackgroundGray"] = "var(--color-semantic-surface-subtle)";
    Colors["Berry"] = "var(--color-semantic-surface-highlight-berry-moderate)";
    Colors["Black"] = "var(--color-semantic-surface-inverse)";
    Colors["DarkAqua"] = "var(--color-semantic-surface-highlight-smoke-strong)";
    Colors["DarkBerry"] = "var(--color-semantic-surface-highlight-berry-strong)";
    Colors["DarkGray"] = "var(--color-semantic-surface-dark)";
    Colors["DarkGreen"] = "var(--color-semantic-surface-highlight-moss-strong)";
    Colors["DarkMoss"] = "var(--color-semantic-surface-highlight-moss-strong)";
    Colors["DarkOrange"] = "var(--color-semantic-surface-accent)";
    Colors["DarkRed"] = "var(--color-semantic-surface-highlight-berry-strong)";
    Colors["DarkSmoke"] = "var(--color-semantic-surface-highlight-smoke-strong)";
    Colors["FadedAqua"] = "var(--color-semantic-surface-highlight-smoke-moderate)";
    Colors["FadedBerry"] = "var(--color-semantic-surface-highlight-berry-moderate)";
    Colors["FadedGray"] = "var(--color-semantic-surface-moderate)";
    Colors["FadedGreen"] = "var(--color-semantic-surface-highlight-moss-moderate)";
    Colors["FadedMoss"] = "var(--color-semantic-surface-highlight-moss-moderate)";
    Colors["FadedRed"] = "var(--color-semantic-surface-highlight-berry-moderate)";
    Colors["FadedSmoke"] = "var(--color-semantic-surface-highlight-smoke-moderate)";
    Colors["Gray"] = "var(--color-semantic-surface-moderate)";
    Colors["Green"] = "var(--color-semantic-surface-highlight-moss-moderate)";
    Colors["LightAqua"] = "var(--color-semantic-surface-highlight-smoke-subtle)";
    Colors["LightBerry"] = "var(--color-semantic-surface-highlight-berry-subtle)";
    Colors["LightGray"] = "var(--color-semantic-surface-subtle)";
    Colors["LightGreen"] = "var(--color-semantic-surface-highlight-moss-subtle)";
    Colors["LightMoss"] = "var(--color-semantic-surface-highlight-moss-subtle)";
    Colors["LightRed"] = "var(--color-semantic-surface-highlight-berry-subtle)";
    Colors["LightSmoke"] = "var(--color-semantic-surface-highlight-smoke-subtle)";
    Colors["Moss"] = "var(--color-semantic-surface-highlight-moss-moderate)";
    Colors["Orange"] = "var(--color-semantic-surface-accent)";
    Colors["Red"] = "var(--color-semantic-surface-highlight-berry-moderate)";
    Colors["Smoke"] = "var(--color-semantic-surface-highlight-smoke-moderate)";
    Colors["White"] = "var(--color-semantic-surface-standard)";
    Colors["HighlightMossModerate"] = "var(--color-semantic-surface-highlight-moss-moderate)";
    Colors["HighlightMossSubtle"] = "var(--color-semantic-surface-highlight-moss-subtle)";
    return Colors;
}({});

//# sourceMappingURL=colors.js.map